import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { FILTER_LOCATION_NAME } from 'dpl/constants/query_params';

/** @param {any} props */
export default function ResultsHeading({ className = null }) {
  const { breedName, locationTitle } = useSelector(({ server }) => server);

  const locName = useSelector(
    ({ queryParams }) => queryParams[FILTER_LOCATION_NAME]
  );

  const location = locName || locationTitle;

  return (
    <h1
      className={classnames(
        'font-14 md:font-16 font-sans fw-normal lh-title secondary',
        className
      )}
    >
      40+ {breedName} puppies for sale from ethical breeders
      {location && ` near ${location}`}
    </h1>
  );
}

ResultsHeading.propTypes = {
  className: PropTypes.string
};
